import React, { useEffect, useState } from "react";
import { getAllProperties, getPropertiesBySearchParams } from "../services/propertyService";
import { Box, Grid2, Pagination } from "@mui/material";
import Product from "./section-components/product";
import EnhancedPropertyCard from "./EnhancedPropertyCard";
import SearchBar from "./section-components/SearchBar";
import { Pageheader } from "./global-components/page-header";
import Service from './section-components/service';
import service_1 from '../assets/img/service/Lettings - Full management ICON.png';
import service_2 from '../assets/img/service/Lettings - Rent collection service.png';
import service_3 from '../assets/img/service/Lettings - Tenant find.png';
import bgImage from '../assets/img/newimgaes/Lettings Main Photo.jpeg';
import Toast from "../components/Toast";

export const Letting = () => {
    const [properties, setProperties] = useState([]);
    const [searchParams, setSearchParam] = useState({});
    const [page, setPage] = useState(1);
    const itemsPerPage = 9;
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    let services = [
        {
            type: 'Full Property Management with Rent Protection Service',
            description: (<>Our <strong>property management service with rent protection</strong> offers complete peace of mind for landlords. We handle everything from <strong>tenant sourcing</strong> and <strong>rent collection</strong> to full property maintenance and compliance checks. Let our experts manage your property while you enjoy guaranteed rental income and stress-free ownership.</>),
            link: '',
            img: service_1,
            filter: "invert(100%) brightness(90%) contrast(1)",
            buttonName: 'Explore Full Property Management',
            navigation: '/property-management'

        },
        {
            type: 'Reliable Rent Collection Service in Coventry & Rugby',
            description: (<>Our dedicated <strong>rent collection service</strong> ensures timely and consistent payments throughout the tenancy period. While you retain control over property maintenance, we handle the financial side — monitoring rent payments, managing arrears, and providing monthly reports to landlords in <strong>Coventry, Rugby, and West Midlands</strong>.</>),
            link: '',
            img: service_2,
            filter: "invert(100%) brightness(90%) contrast(1)",
            buttonName: 'View Our Letting & Legal Services',
            navigation: '/services'
        },
        {
            type: 'Tenant Find Service – We Handle Search & Screening',
            description: (<>We specialize in finding the right tenants for your property. Our <strong>tenant find service</strong> includes background checks, employment verification, reference collection, and preparation of professional tenancy agreements. We also handle inventory reports and property condition documentation to ensure a smooth onboarding process — all in compliance with <strong>UK lettings regulations</strong>.</>),
            link: '',
            img: service_3,
            filter: "invert(100%) brightness(90%) contrast(1)",
            buttonName: 'View Our Letting & Legal Services',
            navigation: '/services'

        },
    ]
    useEffect(() => {
        if (Object.keys(searchParams).length === 0) {
            getAllProperties()
                .then((res) => {
                    const rentProperties = res.filter((el) => el.propertyStatus !== 'For Sale' && el.propertyStatus !== 'Sold');
                    setProperties(rentProperties);
                    // setToastMessage("Properties loaded successfully!");
                    // setToastOpen(true);
                })
                .catch((error) => {
                    setToastMessage("Failed to load properties.");
                    setToastOpen(true);
                });
        } else {
            getPropertiesBySearchParams(searchParams)
                .then((res) => {
                    const rentProperties = res.filter((el) => el.propertyStatus !== 'For Sale' &&  el.propertyStatus !== 'Sold');
                    setProperties(rentProperties);
                    // setToastMessage("Search results loaded successfully!");
                    // setToastOpen(true);
                })
                .catch((error) => {
                    setToastMessage("Failed to load search results.");
                    setToastOpen(true);
                });
        }
    }, [searchParams]);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const paginatedProperties = properties.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    return (
        <>
            <Pageheader headertitle="Lettings Services – Property Management Made Easy" isSlider bgImage={bgImage} />
            <Service services={services} statusType={'For Rent'} />
            <SearchBar setSearchBack={setSearchParam} isSell isLetting />
            <div className="container">
                <div className="propartes-area" style={{ paddingTop: '30px' }}>
                    <Grid2 container spacing={2} justifyContent="center">
                        {paginatedProperties.map((property, index) => (
                            <Grid2 key={index} xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <EnhancedPropertyCard property={property} />
                            </Grid2>
                        ))}
                    </Grid2>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: 3,
                            marginBottom: 3,
                        }}
                    >
                        <Pagination
                            count={Math.ceil(properties.length / itemsPerPage)}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </Box>
                </div>
            </div>
            <Toast open={toastOpen} severity='error' message={toastMessage} onClose={() => setToastOpen(false)} />
        </>
    );
};
